class KlaviyoSignup extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.form = this.querySelector("form");
    if (this.form) {
      this.form.addEventListener("submit", (e) => {
        e.preventDefault();
        this.submitForm(e);
      });
    }
  }

  async submitForm(e) {
    const error = this.querySelector(".error");
    const success = this.querySelector(".success");
    const successContainer = this.querySelector("[data-klaviyo-success]");
    const email = this.form.querySelector('[type="email"]');
    const zip = this.form.querySelector('[type="text"]');
    const submit = this.form.querySelector('[type="submit"]');
    const listId = this.dataset.listId;
    const countryIso = (
      this.dataset.countryIso ||
      window.Shopify?.country ||
      ""
    ).toUpperCase();
    const countryName = this.dataset.countryName || "";
    const region = window.Shopify?.customerPrivacy?.getRegion?.() || "";
    const isUS = region.includes("US") || countryIso === "US";
    const isUK = region.includes("GB") || countryIso === "GB";

    error.innerHTML = "";

    const submitText = submit.innerHTML;

    submit.innerHTML = "Submitting...";

    try {
      const postalCode = (zip.value || "").trim();
      const normalizeRegion = (value, prefix) => {
        if (!value || !value.includes(prefix)) return "";
        return value.split(prefix)[1]?.replace(/^[-_]/, "") || "";
      };

      const location = {
        zip: postalCode,
      };

      if (isUS) {
        location.country = "United States";
        location.region = normalizeRegion(region, "US");
      } else if (isUK) {
        location.country = "United Kingdom";
        location.region = normalizeRegion(region, "GB");
      } else if (countryName) {
        location.country = countryName;
      } else if (countryIso) {
        location.country = countryIso;
      }

      if (
        location.country === "United States" &&
        postalCode &&
        postalCode.length < 5
      ) {
        throw new Error("Zip code must be 5 digits.");
      }

      if (location.country === "United Kingdom") {
        const ukRegex = /^[A-Z]{1,2}[0-9][0-9A-Z]?\s?[0-9][A-Z]{2}$/i;
        if (!ukRegex.test(postalCode)) {
          throw new Error("Please enter a valid Postcode.");
        }
      }

      if (
        location.country !== "United Kingdom" &&
        location.country !== "United States" &&
        postalCode &&
        postalCode.length < 4
      ) {
        throw new Error("Zip code must be at least 4 digits.");
      }

      const signUpSource = isUS ? "US" : isUK ? "UK" : "INT";
      const updateableSource = countryIso
        ? countryIso === "GB"
          ? "UK"
          : countryIso
        : signUpSource;

      const properties = {
        ad_personalization: "granted",
        ad_user_data: "granted",
        "Accepts Marketing": true,
        sign_up_source: signUpSource,
        updateable_source: updateableSource,
      };

      const locale = isUS ? "en-US" : isUK ? "en-GB" : "";

      const payload = {
        data: {
          type: "subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: email.value,
                  location,
                  ...(locale && { locale }),
                  subscriptions: {
                    email: { marketing: { consent: "SUBSCRIBED" } },
                  },
                  properties,
                },
              },
            },
            custom_source: "Custom footer form",
          },
          ...(listId && {
            relationships: { list: { data: { type: "list", id: listId } } },
          }),
        },
      };
      const resp = await fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=UYwKnY`,
        {
          method: "POST",
          headers: {
            Accept: "application/vnd.api+json",
            "Content-Type": "application/vnd.api+json",
            revision: "2025-01-15",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!resp.ok) {
        const errorData = await resp.json();
        throw new Error(
          errorData.errors?.[0]?.detail || "Klaviyo subscription request failed"
        );
      }

      this.form.reset();
      submit.innerHTML = submitText;
      if (success) success.classList.remove("hidden");
      if (this.form) this.form.classList.add("hidden");
      if (successContainer) successContainer.classList.remove("hidden");
      email.blur();
      zip.blur();
    } catch (e) {
      error.classList.remove("hidden");
      error.innerHTML =
        e.message || "Oops, there was an error. Please try again.";
      submit.innerHTML = submitText;
    }
  }
}

customElements.define("klaviyo-signup", KlaviyoSignup);
